export default {
  getUserTasks: state => state.userTasks,
  isMobile: state => state.isMobile,
  isTablet: state => state.isTablet,
  isDesktop: state => state.isDesktop,
  colors: state => state.colors || {},
  surveyProfile: state => state.surveyProfile
};
